import { useEffect, useState } from "react";

export interface SizeAndScroll {
  width: number;
  height: number;
  scroll: number;
}

export const useElementSizeAndScroll = (selectors: string, hidden = false) => {
  const [size, setSize] = useState<SizeAndScroll>({
    width: 0,
    height: 0,
    scroll: 0,
  });

  useEffect(() => {
    if (hidden) return () => {};

    const el = document.querySelector<HTMLElement>(selectors);

    const eventHandler = () => {
      if (!el) return;

      setSize({
        width: el.offsetWidth,
        height: el.offsetHeight,
        scroll: el.scrollLeft,
      });
    };

    if (el) {
      setSize({
        width: el.offsetWidth,
        height: el.offsetHeight,
        scroll: el.scrollLeft,
      });

      el.addEventListener("scroll", eventHandler);
      el.addEventListener("resize", eventHandler);
    }

    return () => {
      el?.removeEventListener("scroll", eventHandler);
      el?.removeEventListener("resize", eventHandler);
    };
  }, [hidden, selectors]);

  return size;
};
